<template>
  <div class="configurator-visual" aria-hidden="true">
    <div class="configurator-visual__chip">
      <ShowcasePill tone="green">NIEUW</ShowcasePill>
      <span>Aanvraag ontvangen</span>
    </div>

    <div class="configurator-visual__screen">
      <div class="configurator-visual__title">
        <span>Solar screen</span>
        <ShowcasePill tone="blue">STAP 2 VAN 4</ShowcasePill>
      </div>

      <div class="configurator-visual__sizes">
        <div v-for="size in sizes" :key="size.label" class="configurator-visual__size">
          <span class="configurator-visual__label">{{ size.label }}</span>
          <div class="configurator-visual__field">
            <span>{{ size.value }}</span>
            <span>mm</span>
          </div>
        </div>
      </div>

      <span class="configurator-visual__label">DOEKKLEUR</span>
      <div class="configurator-visual__colors">
        <span
          v-for="(color, index) in colors"
          :key="color"
          class="configurator-visual__color"
          :class="{ 'configurator-visual__color--selected': index === 0 }"
          :style="{ backgroundColor: color }"
        ></span>
      </div>

      <span class="configurator-visual__label">BEDIENING</span>
      <div class="configurator-visual__options">
        <div
          v-for="option in options"
          :key="option.label"
          class="configurator-visual__option"
          :class="{ 'configurator-visual__option--selected': option.selected }"
        >
          <img
            :src="option.selected ? radioSelectedIcon : radioIcon"
            alt=""
            width="14"
            height="14"
          />
          <span>{{ option.label }}</span>
          <span class="configurator-visual__option-price">{{ option.price }}</span>
        </div>
      </div>

      <div class="configurator-visual__total">
        <span>Prijsindicatie incl. montage</span>
        <strong>€ 1.248</strong>
      </div>
    </div>
  </div>
</template>

<script>
  import radioIcon from '@/assets/img/login/radio.svg';
  import radioSelectedIcon from '@/assets/img/login/radio-selected.svg';

  import ShowcasePill from './ShowcasePill.vue';

  export default {
    name: 'ConfiguratorVisual',
    components: { ShowcasePill },
    setup() {
      const sizes = [
        { label: 'BREEDTE', value: '2.400' },
        { label: 'HOOGTE', value: '1.800' },
      ];
      const colors = ['#2b2b2b', '#6d6a64', '#b9b2a4', '#e7e3da', '#3c4a5c'];
      const options = [
        { label: 'Handmatig', price: 'incl.', selected: false },
        { label: 'Somfy motor', price: '+ €285', selected: true },
      ];

      return { sizes, colors, options, radioIcon, radioSelectedIcon };
    },
  };
</script>

<style scoped lang="scss">
  .configurator-visual {
    position: relative;
    width: 520px;
    max-width: 100%;
    padding-top: 1.25rem;
    color: var(--showcase-ink);

    &__chip {
      position: absolute;
      top: 0;
      right: 110px;
      z-index: 1;
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 7px 11px;
      border: 1px solid var(--showcase-stroke);
      border-radius: 8px;
      background-color: var(--white);
      font-size: 12.5px;
      line-height: 18px;
      box-shadow:
        0 1px 2px rgba(0, 9, 33, 0.06),
        0 8px 24px rgba(0, 9, 33, 0.07);
    }

    &__screen {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 18px;
      border: 1px solid var(--showcase-stroke);
      border-radius: 10px;
      background-color: var(--white);
      filter: drop-shadow(0 1px 1px rgba(0, 9, 33, 0.06)) drop-shadow(0 8px 12px rgba(0, 9, 33, 0.07));
    }

    &__title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      margin-bottom: 4px;
      font-size: 15px;
      font-weight: 500;
      line-height: 22px;
    }

    &__sizes,
    &__options {
      display: flex;
      gap: 10px;
      width: 100%;
    }

    &__size {
      display: flex;
      flex: 1;
      flex-direction: column;
      min-width: 0;
    }

    &__label {
      padding: 10px 0 4px;
      color: var(--showcase-muted);
      font-size: 10px;
      font-weight: 500;
      line-height: 15px;
      letter-spacing: 0.4px;
    }

    &__field,
    &__option {
      display: flex;
      align-items: center;
      padding: 7px 10px;
      border: 1px solid var(--showcase-stroke);
      border-radius: 6px;
      font-size: 13px;
      line-height: 20px;
    }

    &__field {
      justify-content: space-between;
    }

    &__colors {
      display: flex;
      gap: 8px;
      padding: 2px 0 2px 2px;
    }

    &__color {
      position: relative;
      width: 28px;
      height: 28px;
      border: 1px solid var(--showcase-stroke);
      border-radius: 6px;
      &--selected::after {
        content: '';
        position: absolute;
        top: -5px;
        left: -5px;
        width: 36px;
        height: 36px;
        box-sizing: border-box;
        border: 2px solid var(--showcase-primary);
        border-radius: 8px;
      }
    }

    &__option {
      flex: 1;
      gap: 8px;
      min-width: 0;
      &--selected {
        border-color: var(--showcase-primary);
        background-color: var(--showcase-primary-tint);
      }
    }

    &__option-price {
      margin-left: auto;
      color: var(--showcase-text);
      white-space: nowrap;
    }

    &__total {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      margin-top: 14px;
      padding-top: 12px;
      border-top: 1px solid var(--showcase-stroke);
      color: var(--showcase-text);
      font-size: 13px;
      line-height: 20px;
      strong {
        color: var(--showcase-ink);
        font-size: 20px;
        font-weight: 500;
        line-height: 28px;
      }
    }
  }
</style>
